export * from './duration-text.module';
export * from './duration-text.component';
